import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { AlertCircle, Flame, CalendarClock, Scale, HeartHandshake } from 'lucide-react';
export function ProblemSection() {
  return <Section background="cream-dark" className="border-t border-brand-gold/10" data-id="element-211">
      <div className="max-w-3xl mx-auto text-center" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-213">
          <div className="mb-8 flex justify-center" data-id="element-214">
            <div className="h-1 w-20 bg-brand-gold rounded-full" data-id="element-215"></div>
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif italic text-brand-charcoal-dark mb-8 leading-relaxed" data-id="element-216">
            "Son las 3 de la tarde. Tienes 40 pestañas abiertas en el navegador,
            12 mensajes sin leer y una presión sorda en el pecho que no te deja
            pensar."
          </h2>

          <p className="text-lg text-brand-charcoal/80 mb-10 leading-relaxed" data-id="element-217">
            Sabes lo que tienes que hacer, pero tu cerebro simplemente...{' '}
            <span className="font-bold text-brand-charcoal-dark" data-id="element-218">
              no arranca.
            </span>
          </p>

          {/* Emotional connection points */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 text-left" data-id="element-219">
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-brand-gold/10" data-id="element-220">
              <Flame className="h-5 w-5 text-brand-gold-dark flex-shrink-0 mt-0.5" data-id="element-221" />
              <div data-id="element-222">
                <p className="font-bold text-brand-charcoal-dark text-sm" data-id="element-223">
                  Te sientes estresada
                </p>
                <p className="text-xs text-brand-charcoal/60" data-id="element-224">
                  El peso del día se acumula y no encuentras alivio.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-brand-gold/10" data-id="element-225">
              <CalendarClock className="h-5 w-5 text-brand-gold-dark flex-shrink-0 mt-0.5" data-id="element-226" />
              <div data-id="element-227">
                <p className="font-bold text-brand-charcoal-dark text-sm" data-id="element-228">
                  Rutina saturada
                </p>
                <p className="text-xs text-brand-charcoal/60" data-id="element-229">
                  Tu agenda está llena pero sientes que no avanzas.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-brand-gold/10" data-id="element-230">
              <Scale className="h-5 w-5 text-brand-gold-dark flex-shrink-0 mt-0.5" data-id="element-231" />
              <div data-id="element-232">
                <p className="font-bold text-brand-charcoal-dark text-sm" data-id="element-233">
                  Te cuesta mantener equilibrio
                </p>
                <p className="text-xs text-brand-charcoal/60" data-id="element-234">
                  Trabajo, salud, familia... algo siempre se sacrifica.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-brand-gold/10" data-id="element-235">
              <HeartHandshake className="h-5 w-5 text-brand-gold-dark flex-shrink-0 mt-0.5" data-id="element-236" />
              <div data-id="element-237">
                <p className="font-bold text-brand-charcoal-dark text-sm" data-id="element-238">
                  Quieres apoyo diario simple
                </p>
                <p className="text-xs text-brand-charcoal/60" data-id="element-239">
                  No necesitas más teoría, necesitas algo que funcione ya.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-5 sm:p-8 rounded-lg shadow-sm border border-brand-gold/20 text-left relative overflow-hidden" data-id="element-240">
            <div className="absolute top-0 left-0 w-1 h-full bg-brand-gold" data-id="element-241"></div>
            <div className="flex items-start gap-3 sm:gap-4" data-id="element-242">
              <AlertCircle className="h-5 w-5 sm:h-6 sm:w-6 text-brand-gold-dark flex-shrink-0 mt-1" data-id="element-243" />
              <div data-id="element-244">
                <h3 className="text-lg sm:text-xl font-bold text-brand-charcoal-dark mb-2" data-id="element-245">
                  Lo llaman "Bloqueo". La ciencia lo llama Toxicidad por
                  Cortisol.
                </h3>
                <p className="text-sm sm:text-base text-brand-charcoal/70" data-id="element-246">
                  Estás operando en modo supervivencia. Y en ese modo, nadie
                  toma buenas decisiones. Nadie escala negocios. Nadie es feliz.
                  Tu cuerpo está gritando "peligro" cuando solo estás intentando
                  responder un email.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}